import ExcelJS from 'exceljs'
import * as FileSaver from 'file-saver'

export const downloadJSON2CSV = async function (headers, data) {
  // Paso 1: Crear el contenido del archivo CSV
  const csvRows = []

  // Paso 2: Añadir los encabezados al CSV
  csvRows.push(headers.map(header => {
    const escapedValue = ('' + header.text).replace(/"/g, '""')
    return `"${escapedValue}"`
  }).join(';'))

  // Paso 3: Añadir las filas de datos al CSV
  data.forEach(row => {
    // Solo extraer los valores que corresponden a los headers
    const values = headers.map(header => header.value).map(header => {
      const rawValue = row[header] == null ? '' : row[header]
      const escapedValue = ('' + rawValue).replace(/"/g, '""') // Escapar comillas y manejar valores indefinidos
      return `"${escapedValue}"` // Encerrar en comillas dobles para manejar casos con comas
    })
    csvRows.push(values.join(';'))
  })

  // Paso 4: Convertir el array de filas CSV en un string
  const csvString = csvRows.join('\n')

  // Paso 5: Añadir el BOM (Byte Order Mark) para UTF-8
  const bom = '\uFEFF'

  // Paso 6: Crear un blob a partir del string CSV con BOM incluido
  const blob = new Blob([bom + csvString], { type: 'text/csv;charset=utf-8;' })

  // Paso 7: Crear un enlace de descarga
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'descarga.csv'
  document.body.appendChild(a)
  a.click()

  // Paso 8: Limpiar el DOM
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}

export async function downloadDispositivosExcel (headers, data, filename = 'dispositivos.xlsx') {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('Dispositivos')

  worksheet.columns = headers.map(h => ({
    header: h.text,
    key: h.value,
    width: 30
  }))

  data.forEach(row => {
    const dataRow = {}
    headers.forEach(h => {
      dataRow[h.value] = row[h.value]
    })
    worksheet.addRow(dataRow)
  })

  worksheet.columns.forEach(col => {
    col.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
  })

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  FileSaver.saveAs(blob, filename)
}
